// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniChat_chat__xeNbZ {
  background: #FFFFFF;
  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01), 0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09), 0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  border-radius: 4px 4px 0 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 1000;
  max-width: max(100%, 100vw);
  max-height: max(100%, 100vh);
}
.MiniChat_chatMobile__3QUUx {
  width: 100% !important;
  height: 100% !important;
}
.MiniChat_chatExpanded__tysip {
  width: calc(100% - 334px) !important;
  height: calc(100% - 62px) !important;
}

.MiniChat_header__eClJB {
  flex-shrink: 0;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}
.MiniChat_headerMoving__vMW5F {
  cursor: grabbing;
}

.MiniChat_content__50KQG {
  display: flex;
  flex-direction: column;
  min-height: 1px;
  flex-grow: 1;
}

.MiniChat_messages__y4ZvY {
  min-height: 1px;
  flex-grow: 1;
  flex-shrink: 1;
}

.MiniChat_bottomAction__mbdZS {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MiniChat/MiniChat.module.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,uLAAA;EACA,eAAA;EACA,0BAAA;EAEA,aAAA;EACA,sBAAA;EACA,oBAAA;EAEA,aAAA;EACA,2BAAA;EACA,4BAAA;AAEF;AAAE;EACE,sBAAA;EACA,uBAAA;AAEJ;AACE;EACE,oCAAA;EACA,oCAAA;AACJ;;AAGA;EACE,cAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAFF;;AAKA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":["@import '@/assets/scss/config.module.scss';\n\n.chat {\n  background: #FFFFFF;\n  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01), 0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09), 0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  border-radius: 4px 4px 0 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  z-index: 1000;\n  max-width: max(100%, 100vw);\n  max-height: max(100%, 100vh);\n\n  &Mobile {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  &Expanded {\n    width: calc(100% - $sidebar-width) !important;\n    height: calc(100% - $header-height) !important;\n  }\n}\n\n.header {\n  flex-shrink: 0;\n  cursor: grab;\n  user-select: none;\n\n  &Moving {\n    cursor: grabbing;\n  }\n  //user-select: none;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  min-height: 1px;\n  flex-grow: 1;\n}\n\n.messages {\n  min-height: 1px;\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.bottomAction {\n  flex-shrink: 0;\n}\n//\n//@media (screen or max-width: 500px) {\n//  .chat {\n//    width: 100% !important;\n//    height: 100% !important;\n//  }\n//}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileSidebarBreakpointWidth": `700px`,
	"sidebarWidth": `334px`,
	"chat": `MiniChat_chat__xeNbZ`,
	"chatMobile": `MiniChat_chatMobile__3QUUx`,
	"chatExpanded": `MiniChat_chatExpanded__tysip`,
	"header": `MiniChat_header__eClJB`,
	"headerMoving": `MiniChat_headerMoving__vMW5F`,
	"content": `MiniChat_content__50KQG`,
	"messages": `MiniChat_messages__y4ZvY`,
	"bottomAction": `MiniChat_bottomAction__mbdZS`
};
export default ___CSS_LOADER_EXPORT___;
